import { EntityMetadataMap, EntityDataModuleConfig } from '@ngrx/data';

const entityMetadata: EntityMetadataMap = {
  Contact: {
    entityDispatcherOptions: {
      optimisticUpdate: false,
      optimisticAdd: false,
    },
    selectId: (entity) => entity.uuid,
  },
  HealthPackage: {
    entityDispatcherOptions: {
      optimisticUpdate: true,
    },
    selectId: (entity) => entity.uuid,
  },
};

const pluralNames = {};

export const entityConfig: EntityDataModuleConfig = {
  entityMetadata,
  pluralNames,
};
